import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts/:account_id/donations/:id', {
        template: require('./account_donation.html'),
        controller: 'AccountDonationController'
    });
})
.controller('AccountDonationController', function($scope, $location, $routeParams, Account, Donation) {
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.account = Account.get({ id: $routeParams.account_id });
    $scope.donation = Donation.get({ account_id: $routeParams.account_id, id: $routeParams.id });

    $scope.isRefunding = false;
    return $scope.refund = function() {
        if (confirm('Are you sure you want to refund this donation?')) {
            $scope.isRefunding = true;
            return Donation.refund({ account_id: $routeParams.account_id, id: $routeParams.id }, { id: $routeParams.id }, (data => $scope.donation = data));
        }
    };
});


// WEBPACK FOOTER //
// ./views/account/account_donation_controller.js